import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/commercial-storage-near-me.jpg'),
    alt: 'commercial storage near me page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'commercial storage near me page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Reliable <span>Commercial</span><span>Storage Near Me</span>',
  description:
    'Find reliable and secure commercial storage options near you for your business needs like; storing inventory, equipment, or documents.',
  image: {
    url: '/images/v2/pages/landing-pages/commercial-storage-near-me/hero-image.jpg',
    alt: 'Reliable Commercial Storage Near Me'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Commercial Storage Near You' }
}

export const ourProcessSectionContent = {
  title: 'How Commercial Storage Near Me Works',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/commercial-storage-near-me/how-commercial-storage-near-me-works.png',
    alt: 'How Commercial Storage Near Me Works'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Online Booking',
      description:
        'Reserve your commercial storage space online with ease, selecting the size and duration that suits your business needs.',
      image: {
        src: '/images/v2/pages/landing-pages/commercial-storage-near-me/easy-online-booking.png',
        alt: 'Easy Online Booking'
      }
    },
    {
      id: 2,
      title: 'Flexible Storage Options',
      description:
        'Choose from various storage unit sizes, from small spaces for documents to larger units for equipment or inventory.',
      image: {
        src: '/images/v2/pages/landing-pages/commercial-storage-near-me/flexible-storage-options.png',
        alt: 'Flexible Storage Options'
      }
    },
    {
      id: 3,
      title: 'Safe and Secure Facilities',
      description:
        'Rest assured that your business assets are stored in secure, monitored facilities with 24/7 surveillance and climate control options.',
      image: {
        src: '/images/v2/pages/landing-pages/commercial-storage-near-me/safe-and-secure-facilities.png',
        alt: 'Safe and Secure Facilities'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Fast Commercial Storage Services Near Me',
  description:
    'Our commercial storage options offer convenience, security, and flexibility for businesses in need of extra space. With a variety of services and storage solutions, we ensure that your items are well-protected and accessible whenever you need them.',
  image: {
    src: '/images/v2/pages/landing-pages/commercial-storage-near-me/fast-commercial-storage-services-near-me.jpg',
    alt: 'Fast Commercial Storage Services Near Me'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Commercial Storage Near Me',

  cards: [
    {
      id: 1,
      title: 'Convenient Location',
      description:
        'Find storage units close to your business, so you don’t have to travel far to access your inventory or equipment.',
      image: {
        src: '/images/v2/pages/common/convenient-locations.png',
        alt: 'Convenient Location'
      }
    },
    {
      id: 2,
      title: 'Affordable Solutions',
      description:
        'Our pricing is designed to be competitive, providing affordable storage solutions for businesses of all sizes.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Affordable Solutions'
      }
    },
    {
      id: 3,
      title: 'Secure and Accessible',
      description:
        'With 24/7 access and advanced security measures, you can easily access your items anytime while knowing they’re safe.',
      image: {
        src: '/images/v2/pages/common/enhanced-security2.png',
        alt: 'Secure and Accessible'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Commercial Storage Near Me?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Small Businesses',
          description: 'Store inventory, office supplies, or equipment without the need for a large office space.'
        },
        {
          id: 2,
          title: 'E-commerce Companies',
          description: 'Keep your products organized and easily accessible for quick shipping and inventory management.'
        },
        {
          id: 3,
          title: 'Contractors and Tradespeople',
          description:
            'Store tools, equipment, and materials safely and securely until they are needed on the job site.'
        },
        {
          id: 4,
          title: 'Retailers',
          description:
            'Keep extra stock or seasonal inventory organized and close to your business location for efficient distribution.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/commercial-storage-near-me/who-should-use-commercial-storage-near-me.jpg',
        alt: 'Who Should Use Commercial Storage Near Me?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Commercial Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Inventory Storage',
      description: 'Store your business inventory securely with easy access whenever you need to restock.',
      image: {
        src: '/images/v2/pages/common/short-term-and-long-term-storage.png',
        alt: 'Business Inventory Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Equipment Storage',
      description: 'Keep your valuable equipment, machinery, or tools safe and ready for use at a moment’s notice.',
      image: {
        src: '/images/v2/pages/common/specialty-item-shipping.png',
        alt: 'Equipment Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Document Storage',
      description: 'Organize and securely store important business documents and files in a climate-controlled unit.',
      image: {
        src: '/images/v2/pages/common/improved-organization.png',
        alt: 'Document Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Retail Storage Solutions',
      description: 'Store extra retail items or seasonal stock in a secure facility near your store.',
      image: {
        src: '/images/v2/pages/common/residential-storage-services.png',
        alt: 'Retail Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Commercial Storage Near Me?',

  image: {
    url: '/images/v2/pages/landing-pages/commercial-storage-near-me/why-choose-us-for-commercial-storage-near-me.jpg',
    alt: 'Why Choose Us for Commercial Storage Near Me?'
  },

  articles: [
    {
      id: 1,
      title: 'Convenient Locations',
      description:
        'Our storage facilities are strategically located near your business to provide quick and easy access.'
    },
    {
      id: 2,
      title: 'Affordable Rates',
      description:
        'Our competitive pricing ensures that your business gets the storage it needs without breaking the budget.'
    },
    {
      id: 3,
      title: 'Variety of Unit Sizes',
      description:
        'Choose from a range of unit sizes that meet the unique needs of your business, whether you have a few boxes or large equipment.'
    },
    {
      id: 4,
      title: 'Flexible Access',
      description: 'Enjoy convenient, flexible access to your stored items, day or night, whenever you need them.'
    },
    {
      id: 5,
      title: '24/7 Security',
      description:
        'Your belongings are stored in secure, monitored facilities with 24/7 surveillance to ensure protection.'
    },
    {
      id: 6,
      title: 'Professional Support',
      description:
        'Our knowledgeable staff is always ready to assist you with any questions or concerns, ensuring a smooth storage experience.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Commercial Storage Services Near Me Fast And Reliable',
  description:
    'Find reliable commercial storage services near me. Fast, secure, and affordable options for storing your business items safely.',
  image: {
    src: '/images/v2/pages/landing-pages/commercial-storage-near-me/commercial-storage-services-near-me-fast-and-reliable.png',
    alt: 'Commercial Storage Services Near Me Fast And Reliable'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Find Storage Near You' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description: 'We work with global logistics providers to offer secure and efficient commercial storage services.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx provides reliable shipping services to help your business access its stored items easily and quickly.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers dependable international shipping options to support your business storage and delivery needs.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides efficient shipping and storage solutions to help businesses manage their stored items and streamline operations.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
